import React, { useEffect, useState } from "react";
import cookies from "js-cookie";

import API from "../../API";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "./Header";

interface Props {}

const AdminLogin: React.FC<Props> = (props) => {
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const [checkingAuth, setCheckingAuth] = useState<boolean>(true);
  // After a correct password the server emails a code; this switches the
  // form to the code-entry step.
  const [awaitingCode, setAwaitingCode] = useState<boolean>(false);
  const [loginMessage, setLoginMessage] = useState<string>("");
  const [currentHousehold, setCurrentHousehold] = useState<any>({
    id: "",
    household_name: "",
    street_address: "",
    zip_code: "",
    contact_person: "",
    phone_number: "",
    country_of_origin: "",
    preferred_language: "",
    preferred_contact_method: "",
    people: [],
    order_date: "",
    pending_action: "",
  });
  const navigate = useNavigate();

  const errorDetail = async (response: Response, fallback: string) => {
    try {
      return (await response.json()).detail || fallback;
    } catch {
      return fallback;
    }
  };

  const handleLogin = async (e: any) => {
    e.preventDefault();

    const response = await API.login(e.target[0].value, e.target[1].value);

    if (response.status === 200) {
      setAwaitingCode(true);
      setLoginMessage("We emailed you a login code.");
    } else {
      alert(await errorDetail(response, "failed, please try again"));
    }
  };

  const handleVerifyCode = async (e: any) => {
    e.preventDefault();

    const response = await API.verifyLoginCode(e.target[0].value);

    if (response.status === 200) {
      setAwaitingCode(false);
      setLoginMessage("");
      setLoggedIn(true);
      API.repullCSRF();
    } else {
      setLoginMessage(await errorDetail(response, "That code didn't work."));
    }
  };

  const handleResendCode = async () => {
    const response = await API.resendLoginCode();

    if (response.status === 200) {
      setLoginMessage("We sent you a new code.");
    } else {
      setLoginMessage(await errorDetail(response, "Couldn't send a new code."));
    }
  };

  const handleStartOver = () => {
    setAwaitingCode(false);
    setLoginMessage("");
  };

  const handleLogout = () => {
    setLoggedIn(false);
    cookies.remove("csrftoken");
    API.logout();
  };

  const handleEditHousehold = (id: any, changes: any) => {
    API.updateHousehold(id, changes);
  };

  const handleToOrder = (household: any) => {
    setCurrentHousehold(household);
    navigate(`/mobileadmin/${household.id}`);
  };

  useEffect(() => {
    API.verify()
      .then((response: any) => {
        response.status === 200 && setLoggedIn(true);
      })
      .finally(() => setCheckingAuth(false));
  }, []);

  if (checkingAuth) {
    return <div className="admin_auth_checking">Loading…</div>;
  }

  return loggedIn ? (
    <div>
      <Header handleLogout={handleLogout} />
      <div className="admin_container">
        <Outlet
          context={{
            currentHousehold,
            setCurrentHousehold,
            handleEditHousehold,
            handleToOrder,
          }}
        />
      </div>
    </div>
  ) : awaitingCode ? (
    <div className="admin_login_container">
      <h1>Admin Login</h1>
      <p>{loginMessage}</p>
      <form onSubmit={(e) => handleVerifyCode(e)}>
        <div>
          <label>Login code</label>
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]{6}"
            maxLength={6}
            required
            autoFocus
          />
        </div>
        <button type="submit">Verify</button>
      </form>
      <button type="button" onClick={handleResendCode}>
        Resend code
      </button>
      <button type="button" onClick={handleStartOver}>
        Start over
      </button>
    </div>
  ) : (
    <div className="admin_login_container">
      <h1>Admin Login</h1>
      <form onSubmit={(e) => handleLogin(e)}>
        <div>
          <label>Username</label>
          <input type="text" required />
        </div>
        <div>
          <label>Password</label>
          <input type="password" required />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default AdminLogin;
